/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
export default {
  "sitecoreApiKey": "DA90FF30-2CCD-4225-87B0-153706950F83",
  "sitecoreApiHost": "https://talkmore.no",
  "jssAppName": "PrivateOrderflow",
  "appPath": "/privat/abonnement/enkelt/bestill",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/sitecore/api/PrivateOrderflow",
  "appBasePath": "/privat/abonnement/",
  "graphQLEndpoint": "https://talkmore.no/sitecore/api/PrivateOrderflow?sc_apikey=DA90FF30-2CCD-4225-87B0-153706950F83"
};